<!--
 * @Author: your name
 * @Date: 2021-11-08 16:47:55
 * @LastEditTime: 2021-11-08 19:16:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \booksnote\src\views\user\login-info.vue
-->
<template>
  <div class="login-info">
    <el-table
      :data="userDataList"
      border
      stripe
      height="83vh"
      :header-cell-style="{
        color: '#000',
        fontSize: '16px',
        backgroundColor: '#ddd',
        textAlign: 'center',
      }"
    >
      <el-table-column align="center" prop="nickname" label="用户名" />
      <el-table-column align="center" prop="groupid" label="群组" />
      <el-table-column align="center" prop="actiontype" label="动作" />
      <el-table-column align="center" prop="actioncontent" label="内容" />
      <el-table-column align="center" prop="createtime" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createtime | get_date }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="查看历史">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="lookDistory(scope)"
          >查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="登录历史" :visible.sync="dialogVisible" width="80%">
      <div>
        <el-table border :data="historyDataList">
          <el-table-column align="center" prop="nickname" label="用户名" />
          <el-table-column align="center" prop="groupid" label="群组" />
          <el-table-column align="center" prop="actiontype" label="动作" />
          <el-table-column align="center" prop="actioncontent" label="内容" />
          <el-table-column align="center" prop="createtime" label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createtime | get_date }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getuh, gethistory } from '@/api/user.js'
export default {
  data() {
    return {
      userDataList: [],
      dialogVisible: false,
      historyDataList: []
    }
  },
  created() {
    getuh().then(res => {
      if (res.data?.length > 0) {
        this.userDataList = res.data
      }
    })
  },
  methods: {
    lookDistory(scope) {
      const { userid } = scope.row
      this.getUserHistory(userid)
      this.dialogVisible = true
    },
    getUserHistory(userid) {
      gethistory({ userid }).then(res => {
        if (res.data && res.data.data) {
          this.historyDataList = res.data.data.map(i => {
            return {
              groupid: res.data.groupid,
              nickname: res.data.nickname,
              userid: res.data.userid,
              actioncontent: i.actioncontent,
              actiontype: i.actiontype,
              createtime: i.createtime
            }
          })
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
</style>
